import { Localized } from "@fluent/react"
import { Alert, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material"
import { useState } from "react"
import { useAppDispatch } from "../../../app/hooks"
import { deleteSuperMailTemplate } from "./superMailTemplatesApi"
import { AppId } from "../../../app/appTypes"
import { showSuccess } from "../../notifications/notificationsSlice"
import { YesButton } from "../../../app/components/YesButton"
import { CancelButton } from "../../../app/components/CancelButton"

export interface RestoreTemplateDialogProps {
    id: AppId,
    onSaveSuccess : (templateId: string) => void
    onCancel  : () => void
}

export const RestoreTemplateDialog = ({ id, onSaveSuccess, onCancel }: RestoreTemplateDialogProps) => {
    const dispatch = useAppDispatch()

    const [saving, setSaving] = useState(false)
    const [serverError, setServerError] = useState("")
    
    const handleConfirmDelClick = async () => {
        setSaving(true)
        try {
            const result = await dispatch(deleteSuperMailTemplate(id))
            if (deleteSuperMailTemplate.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
                onSaveSuccess(id)
            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }
        }
        catch (error) {
            setServerError("error");
        }
        finally {
            setSaving(false)
        }
    }

    const handleCancelDelClick = () => {
        onCancel()
    }

    return <>
        <DialogTitle>
            <Localized id="mail-restore-system">
                <span>Przywróć systemowy</span>
            </Localized>
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                <Alert
                    severity="info"
                    variant="outlined"
                    sx={{
                        mb: 2,
                        mt: 1,
                        alignItems: "flex-start",
                        "& .MuiAlert-message": {
                            width: "100%",
                        },
                    }}
                >
                    <Typography variant="body2">
                        <Localized id="mail-restore-version-question">
                            <span>Czy na pewno chcesz przywrócić systemową wersję?</span>
                        </Localized>
                    </Typography>
                </Alert>
            </DialogContentText>
            {serverError && (
                <Alert sx={{ marginTop: 1 }} severity="error">
                    <Localized id={serverError}>
                        <span style={{ whiteSpace: "pre-line" }}>{serverError}</span>
                    </Localized>
                </Alert>
            )}
        </DialogContent>
        <DialogActions>
            <YesButton loading={saving} onClick={handleConfirmDelClick}/>
            <CancelButton loading={saving} onClick={handleCancelDelClick}/>
        </DialogActions>
    </>
}
